<template>
	<div class="signin">
		<GuestLayout class="box">
			<form @submit.prevent="signIn()" slot="guest-body" class="guest-body" autocomplete="on">
				<InputField
					class="input-line"
					v-model="email"
					:label="'User Name'"
					:placeholder="'Enter email here'"
					:hasError="error.email ? true : false"
					:helperText="error.email?error.email[0]:''"
					type="email"
				/>

				<InputField
					class="input-line"
					v-model="password"
					:label="'Password'"
					:placeholder="'Enter Password'"
					:hasError="error.password ? true : false"
					:helperText="error.password?error.password[0]:''"
					type="password"
					:togglePassword="true"
					:autoComplete="true"
				/>

				<p class="_error" v-if="error">{{ error}}</p>
				<div class="controls">
					<router-link to="/forgot-password">
						{{ 'Forgot Password' }}
					</router-link>

					<button
						class="_primary"
						type="submit"
						:disabled="loading"
					>
						{{ loading ? `${'Loading...'}` : 'Sign In' }}
					</button>

					<!-- <button class="_secondary" type="button" @click="$router.push({ path: '/signup' })">
						{{ 'Sign Up' }}
					</button> -->
				</div>
			</form>
		</GuestLayout>
	</div>
</template>

<script>
import InputField from '@/components/utils/InputField.vue'
import GuestLayout from '@/components/layouts/GuestLayout.vue'
import { mapFields } from 'vuex-map-fields'
export default {
	computed: {
		...mapFields('auth', [
            'email',
            'password',
			'loading',
			'error'
        ]),
	},

	destroyed () {
		this.$store.commit('auth/clearAuth')
	},

	methods: {
		signIn () {
			const form = new FormData()

			form.append('email', this.email)
			form.append('password', this.password)
			this.$store.dispatch('auth/signIn', form)
		}
	},

	components: {
		InputField,
		GuestLayout
	},

	// methods: {
	// 	signIn () {
	// 		let form = new FormData()

	// 		form.append('email', this.email)
	// 		form.append('password', this.password)
	// 		this.$store.dispatch('signIn', form)
	// 	}
	// }
}
</script>

<style scoped lang="scss">
.signin {
	width: 100%;
	height: 100%;

	form {

		.input-line {
			margin-top: 50px;
		}

		.controls {
			padding: 20px 0 20px 0;
			display: flex;
			flex-direction: column;
			align-items: center;

			a {
				color: #3DBFCD;
				font-size: 18px;
				margin-bottom: 20px;

				&:hover {
					color: darken(#3DBFCD,10%);
				}
			}

			button {
				margin-bottom: 20px;
				min-width: 185px;
				padding: 15px 10px;
			}
		}
	}
}
</style>
